/* tslint:disable */

declare var Object: any;
export interface SFEBankingInterface {
  "id"?: number;
}

export class SFEBanking implements SFEBankingInterface {
  "id": number;
  constructor(data?: SFEBankingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFEBanking`.
   */
  public static getModelName() {
    return "SFEBanking";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFEBanking for dynamic purposes.
  **/
  public static factory(data: SFEBankingInterface): SFEBanking{
    return new SFEBanking(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFEBanking',
      plural: 'SFEBankings',
      path: 'SFEBankings',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFEBanking.ts